import { Chart } from "react-google-charts";
import { useEffect, useState } from 'react'
import { Text } from ".."
import api from "../../../services/api";
import { useApp } from "../../../contexts";
import { translateText } from "../../../helpers/util";

export const PieChartOccupationIndustrial = ({ title = "", industrialId }) => {

    const [occupationProfile, setOccupationProfile] = useState([])
    const [load, setLoad] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const { language, translations, userCountry } = useApp();

    useEffect(() => {
        setLoad(true)
        api.get(`/industrial/${industrialId}/occupationprofile`).then(response=>{
            const { occupationProfile } = response.data;
            setOccupationProfile(occupationProfile)
            setLoad(false)
        });

    }, []);

    useEffect(() => {
        setLoaded(load)
    }, [load]);    

    let data = [ 
        [translateText("Segmento", language, translations, userCountry), translateText("Porcentagem", language, translations, userCountry)] 
    ];
    
    occupationProfile.forEach( profile => {
        const result = [];

        result.push(translateText(profile.segment, language, translations, userCountry));
        result.push(parseFloat(profile.perc));

        data.push(result);
    })

    const options = {
        title: title,
        pieSliceText: "none",
        legend: { position: 'left' },
        chartArea: { 
            width: '100%', height: '80%'
        },
        
    };

    return (
        <>
            {/* <LoadComponent isLoading={loaded}> */}
                <Text style={styles.title}>{translateText("Perfil de Ocupação", language, translations, userCountry)}</Text>
                <Chart
                chartType="PieChart"
                data={data}
                options={options}
                width={"100%"}
                height={"100%"}
                />
            {/* </LoadComponent> */}
        </>
    )
}

const styles = {
    title: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#7a7b7c"
    }
}